import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly ACCESS_TOKEN_KEY = 'crm_lanala_access_token';
  private readonly REFRESH_TOKEN_KEY = 'crm_lanala_refresh_token';

  private accessTokenSignal = signal<string | null>(
    typeof localStorage !== 'undefined' ? localStorage.getItem(this.ACCESS_TOKEN_KEY) : null
  );
  
  private refreshTokenSignal = signal<string | null>(
    typeof localStorage !== 'undefined' ? localStorage.getItem(this.REFRESH_TOKEN_KEY) : null
  );

  getAccessToken(): string | null {
    return this.accessTokenSignal();
  }

  setAccessToken(token: string): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(this.ACCESS_TOKEN_KEY, token);
    }
    this.accessTokenSignal.set(token);
  }

  getRefreshToken(): string | null {
    return this.refreshTokenSignal();
  }

  setRefreshToken(token: string): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(this.REFRESH_TOKEN_KEY, token);
    }
    this.refreshTokenSignal.set(token);
  }

  clearTokens(): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(this.ACCESS_TOKEN_KEY);
      localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    }
    this.accessTokenSignal.set(null);
    this.refreshTokenSignal.set(null);
  }
}
